import { gsap, TweenLite, TimelineMax, TweenMax, Elastic, Expo, Sine, Back, Power1, Power2, Power3, Power4 } from 'gsap'

const scrollSpeed = 8000 // PX/sec
const scrollTimeOffset = .5 // PX/sec
// # Distance (PX) to target
const getDistanceToTarget = (target) => {
  const targetTop = target.offsetTop
  return Math.round(Math.abs(window.pageYOffset - targetTop))
}
// # Time of scroll to target animation
const getScrollToTargetTime = (target) => {
  const distance = getDistanceToTarget(target)
  return scrollTimeOffset + distance / scrollSpeed
}
const getWindowScrollTop = () => {
  const doc = document.documentElement
  return (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0)
}
const getTargetTopScrollPos = (target) => {
  // return target.offsetTop
  const rect = target.getBoundingClientRect()
  return rect.top + getWindowScrollTop()
}
export const scrollToTarget = (target, offset = 0, myTime = null, callback = null) => {
  const targetTop = getTargetTopScrollPos(target) + offset
  const time = myTime ? myTime : getScrollToTargetTime(target)
  TweenMax.to(window, time, {scrollTo: {y: targetTop}, ease: Power3.easeInOut, onComplete: callback});
}
